import { hasCapability, type User } from "../base";

export const appeasement = {
  abandon: (user: User) => hasCapability(user, "appeasement.abandon"),
  approve: (user: User) => hasCapability(user, "appeasement.approve"),
  confirmPayment: (user: User) => hasCapability(user, "appeasement.confirmPayment"),
  create: (user: User) => hasCapability(user, "appeasement.create"),
  markSent: (user: User) => hasCapability(user, "appeasement.markSent"),
  read: (user: User) => hasCapability(user, "appeasement.read"),
  reject: (user: User) => hasCapability(user, "appeasement.reject"),
  update: (user: User) => hasCapability(user, "appeasement.update"),
};
